import { weatherMachineChapters } from './content';
export const weatherMachineGlossary = weatherMachineChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('GLOSSARY'));
